const getEventDescriptionText = (event) => {
    const eventDescriptionMarkup = event.eventDescription;
    const eventDescriptionTextNode = document.createElement('div');
    eventDescriptionTextNode.innerHTML = eventDescriptionMarkup;
    return eventDescriptionTextNode.innerText;
}

const AddToCalendar = ({event}) => {
    const eventDescriptionText = getEventDescriptionText(event)

    const {
        city,
        name,
        state,
        street,
        zip
    } = event.venue;

    const compoundAddress = city !== null ? `${name}, ${street}, ${city} ${state} ${zip}` : name;

    return (
        <div title="Add to Calendar" className="addeventatc button cal-ics">
            Add to Calendar +

            <span className="start">{event.msevtmgt_eventstartdate_FormattedValue}</span>
            <span className="end">{event.msevtmgt_eventenddate_FormattedValue}</span>
            <span className="timezone">America/New_York</span>
            <span className="title">{event.msevtmgt_name}</span>
            <span className="description">{eventDescriptionText}</span>
            <span className="location">{compoundAddress}</span>
        </div>
    )
}

export default AddToCalendar;
